import React, { useEffect, useState } from "react";
import "../../css_files/Master/SearchCurrencyMaster.css";
import CloseForm from "./CloseForm";
import axios from "axios";
import { toast } from "react-toastify";
import getCookie from "../../api";
import Swal from "sweetalert2";
import AutoCompleteSearch from "./AutoCompleteSearch";
import axiosInstance from "../../api";
import LoadingScreen from "../Homepage/LoadingScreen";
import Select from "react-select";

function SearchCurrencyMaster({
  setshowsearchform,
  setpagenumber,
  setReload,
  setSearch,
  reload,
}) {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/Currency/GetCurrencyDropdown`
      )
      .then((res) => {
        setOptions(res.data);
      })
      .catch(console.log);
  }, []);
  return (
    <div className="search-currency-master-form">
      <h3>Search Currency Master</h3>

      <blockquote>
        <label>Search</label>
        <input
          type="search"
          placeholder="Enter Search Keyword (Press Enter Key)"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              setSearch(e.target.value?.trim());
              setReload(!reload);
              setpagenumber(1);
            }
          }}
          onInput={(e) => {
            if (e.target.value?.trim() === "") {
              setSearch(e.target.value?.trim());
              setReload(!reload);
              setpagenumber(1);
            }
          }}
        />
      </blockquote>

      <CloseForm
        close={(x) => {
          setshowsearchform(x);
          setSearch("");
          setReload(!reload);
        }}
      />
    </div>
  );
}

export default SearchCurrencyMaster;
